import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything, EnterpriseSolutionDetail } from '@types';

export const useEnterpriseSolution = (): EnterpriseSolutionDetail[] => {
	// keep this hook here to update when translations obtained
	useTranslation();
	const solutionsResources = TranslationHelper.getByKey('mbcp.enterprise.solutions');
	const solutions: EnterpriseSolutionDetail[] = (solutionsResources?.result as Anything) || [];

	return solutions;
};
